<template>
  <div class="careers-jobs" v-if="job">
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="row row-1">
      <div class="text-group">
        <h3 class="text-accent">{{job.date | formatDateDot }} &#124; {{ job.company }}</h3>
        <h1>{{ job.position }}</h1>
      </div>
    </div>
    <div class="jobs-container">
      <div class="unreset news-preview-paragraph" v-html="job.content"></div>
    </div>
    <div class="link-container">
      <router-link :to="`/careers?page=application&position=${job.position}&company=${job.company}`" class="link">
        <span class="text-main">КАНДИДАТСТВАЙ ТУК</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      job: {}
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  },
  watch: {
    '$i18n.locale'() {
      this.checkLang();
    }
  },
  methods: {
    getJob() {
      let url = `${process.env.VUE_APP_BASE_URI}/jobs/${this.$route.query.id}`;

      this.$http
        .get(url)
        .then(result => {
          this.job = result.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    checkLang() {
      if (this.$i18n.locale !== 'bg') {
        this.$snotify.warning(
          'The application jobs are available only in Bulgarian.'
        );
        this.$router.push('/careers');
      }
    }
  },
  mounted() {
    this.checkLang();
    this.getJob();
  }
};
</script>

<style lang="scss" scoped>
.careers-jobs {
  position: relative;
  .row-1 {
    padding-left: $sidesPadding;
    padding-right: $sidesPadding;
  }
}
.jobs-container {
  padding-right: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  padding-left: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
}
select,
select:invalid {
  color: #fff;
}
select option:not([disabled]) {
  color: #000;
}
.link-container {
  display: flex;
  justify-content: center;
  padding: 50px;
  width: 100%;
  .link {
    color: #22075E;
  }
  .link::before {
    background-color: $accentColor;
  }
}

@media screen and (max-width: 1600px) {
  .careers-jobs {
    .row-1 {
      padding-left: $sidesPadding1600;
      padding-right: $sidesPadding1600;
    }
    .jobs-container {
      padding-right: $sidesPadding1600 + $chemicalLarge +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
    }
  }
}
@media screen and (max-width: 1440px) {
  .jobs-container {
    padding-right: $sidesPadding1600 + $chemicalLarge1440 +
      ($sidesPadding1600 / 2);
    padding-left: $sidesPadding1600 + $chemicalLarge1440 +
      ($sidesPadding1600 / 2);
  }
}
@media screen and (max-width: 1280px) {
  .careers-jobs {
    .row-1 {
      padding-left: $sidesPadding1280;
      padding-right: $sidesPadding1280;
    }
    .jobs-container {
      padding-right: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
      padding-left: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
    }
  }
}
@media screen and (max-width: 1000px) {
  .careers-jobs {
    .row-1 {
      padding: $sidesPadding1280;
    }
    .jobs-container {
      padding: $sidesPadding1280;
      padding-right: $sidesPadding1280;
      padding-left: $sidesPadding1280;
    }
  }
  .link-container {
    padding: 30px;
  }
}
@media screen and (max-width: 600px) {
  .careers-jobs {
    .row-1 {
      padding: $sidesPadding600;
    }
    .jobs-container {
      padding: $sidesPadding600;
      padding-top: 0;
    }
  }
}
</style>
